import { User } from '@app/models';
import { DefaultComparisonOption } from '@app/models/default-comparison-option';
import { Language } from '@app/models/language';
import { PersonalSettings } from '@app/models/personal-settings';
import { TrainType } from '@app/pcs/models';
import { UserNotification } from '@app/pcs/settings/models/user-notification';
import * as R from 'ramda';

type GetPersonalSettings = (user: User) => PersonalSettings;
export const getPersonalSettings: GetPersonalSettings = R.prop('personalSettings');

type GetDefaultPageSize = (user: User) => number;
export const getDefaultPageSize: GetDefaultPageSize = R.compose(R.prop('defaultPageSize'), getPersonalSettings);

type GetEmailNotifications = (user: User) => UserNotification[];
export const getEmailNotifications: GetEmailNotifications = R.compose(R.prop('emailNotifications'), getPersonalSettings);

type GetSubscribedTrainTypes = (user: User) => TrainType[];
export const getSubscribedTrainTypes: GetSubscribedTrainTypes = R.compose(R.prop('subscribedTrainTypes'), getPersonalSettings);

type GetFilterId = (user: User) => number;
export const getFilterId: GetFilterId = R.compose(R.prop('id'), R.prop('defaultFilter'), getPersonalSettings);

type GetDefaultDossierView = (user: User) => string;
export const getDefaultDossierView: GetDefaultDossierView = R.compose(R.prop('defaultDossierView'), getPersonalSettings);

type GetLanguage = (user: User) => Language;
export const getLanguage: GetLanguage = R.compose(R.prop('language'), getPersonalSettings);

type GetDefaultTrainType = (user: User) => TrainType;
export const getDefaultTrainType: GetDefaultTrainType = R.compose(R.prop('defaultTrainType'), getPersonalSettings);

type GetLanguageId = (user: User) => string;
export const getLanguageId: GetLanguageId = R.compose(R.prop('id'), getLanguage);

type GetDefaultComparisonOption = (user: User) => DefaultComparisonOption;
export const getDefaultComparisonOption: GetDefaultComparisonOption = R.compose(R.prop('defaultComparisonOption'), getPersonalSettings);
